import { useState, useEffect, useCallback } from "react";
import UserSessionStore from "~/stores/UserSessionStore";

const USER_SESSION_STORE_KEYS = {
  THEME: "code-theme",
} as const;

type Theme = "default" | "solarized";

const getStoredTheme = (): Theme => {
  const storedTheme = UserSessionStore.get(USER_SESSION_STORE_KEYS.THEME);
  return storedTheme === "default" || storedTheme === "solarized" ? storedTheme : "default";
};

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getStoredTheme);

  const toggleTheme = useCallback(() => {
    const newTheme = theme === "default" ? "solarized" : "default";
    setTheme(newTheme);
    UserSessionStore.set(USER_SESSION_STORE_KEYS.THEME, newTheme);
  }, [theme]);

  useEffect(() => {
    const handleThemeChange = (event: { key: string; newValue: Theme }) => {
      if (event.key === USER_SESSION_STORE_KEYS.THEME) {
        setTheme(event.newValue);
      }
    };

    UserSessionStore.on("change", handleThemeChange);
    return () => {
      UserSessionStore.off("change", handleThemeChange);
    };
  }, []);

  return { theme, toggleTheme };
}
